import { render, staticRenderFns } from "./zdyrbchengxing.vue?vue&type=template&id=fe827f9a&scoped=true&"
import script from "./zdyrbchengxing.vue?vue&type=script&lang=js&"
export * from "./zdyrbchengxing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe827f9a",
  null
  
)

export default component.exports